import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "alert",
    template: require("./alert.component.html").default,
    styles: [require("../../styles/index.scss").default, require("./alert.component.scss").default],
})
export class AlertComponent implements OnInit {
    @Input() message: string;

    constructor() {}

    ngOnInit() {}
}
